import { NotificationPreferencesApiClient } from '@fourthwall/services/dist/NotificationPreferencesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useNotificationPreferencesQuery = createQueryHook(
  NotificationPreferencesApiClient.getNotificationPreferences,
  {
    queryKey: ['notificationPreferences'],
  },
)
